module.exports = __webpack_public_path__ + "img/phone2.585566a7.png";